import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService, SESSION_EXPIRED_REASON } from '../../../services/auth.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule]
})
export class LoginComponent implements OnInit {
  isLoading: boolean = false;
  sessionExpired = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit() {
    // Check if user is already authenticated
    if (this.authService.isTokenValid()) {
      this.router.navigate(['/']);
      return;
    }
    this.sessionExpired = this.route.snapshot.queryParamMap.get('reason') === SESSION_EXPIRED_REASON;
  }

  login() {
    this.isLoading = true;
    this.authService.login();
  }
}
